import React from 'react';
import Terminal from './Terminal';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="header">
        <span className="logo">CrystralAI Terminal</span>
        <span className="status" id="conn-status">Connecting...</span>
      </div>
      <div className="terminal-container">
        <Terminal />
      </div>
    </div>
  );
}

export default App;
